import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { yonkersConfig } from "./data";

export default function YonkersPage() {
  return <CityPageTemplate config={yonkersConfig} />;
}